import { createFileRoute } from '@tanstack/react-router';

import { TelephonyAgentListScreen } from '@/features/telephony/components/TelephonyAgentListScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/platform/telephony/agents')({
  beforeLoad: () => {
    requirePermission('did_mapping:read');
  },
  component: PlatformTelephonyAgentsRoute,
  staticData: { crumb: 'Helpline agents' },
});

function PlatformTelephonyAgentsRoute() {
  return <TelephonyAgentListScreen surface="platform" />;
}
